import { MutableRefObject, useRef } from 'react';
import { jwtDecode } from 'jwt-decode';
import { w3cwebsocket } from 'websocket';

import { useUrl } from 'widget/hooks';
import * as Env from 'widget/env';

import useHandleEvent from './use-handle-event/use-handle-event';

interface OpenWsParams {
  setAccessToken: Env.SetState<string | null | undefined>;
  setIsTyping: Env.SetState<boolean>;
  setMessageList: Env.SetState<Env.Message[]>;
}

const useOpenWs = (
  ws: MutableRefObject<w3cwebsocket | null>,
  { setAccessToken, setIsTyping, setMessageList }: OpenWsParams,
) => {
  const { WS_URL } = useUrl();
  const count = useRef(0);

  const handleEvent = useHandleEvent({
    setAccessToken,
    setIsTyping,
    setMessageList,
  });

  const handleClose = (accessToken: string) => {
    if (count.current > 1) return;
    count.current += 1;

    setTimeout(() => openWs(accessToken), 1500);
  };

  const openWs = async (accessToken: string) =>
    new Promise(resolve => {
      try {
        ws.current = new w3cwebsocket(WS_URL);
        ws.current.binaryType = 'arraybuffer';
        ws.current.onmessage = event => handleEvent(event, accessToken);
        ws.current.onclose = () => handleClose(accessToken);

        ws.current.onopen = () => {
          if (ws.current?.readyState != 1) return;
          const user: Env.User = jwtDecode(accessToken);

          ws.current?.send(
            JSON.stringify([
              'authorize',
              { type: 'authorize', userID: user.user_id },
            ]),
          );

          resolve(true);
        };
      } catch {}
    });

  return openWs;
};

export default useOpenWs;
